export type ReferralShareData = {
  title: string;
  text: string;
  url: string;
  prettyLink: string;
};

export function getReferralShareData(
  referralCode: string | boolean
): ReferralShareData {
  const inviteLink = `${process.env.SITE_URL}/referral/${referralCode}`;
  const prettyLink = inviteLink.replace(/\http(s?):\/\//, "");
  return {
    title: `Join Airgraft with me`,
    text: `Just got my Airgraft 2. The vapor is next level. Use my link beIow to join and get an amazing Reward Pod for just $1. Total win!`,
    url: inviteLink,
    prettyLink
  };
}
